/**
 * Quem pode ser da equipe da Westhetics: só e-mail da empresa (RN-AUT-31, decisão T54). Cópia, letra a
 * letra, de `apps/api/supabase/functions/_shared/auth/root-email.ts`, para o campo avisar ao sair dele;
 * `root-email.test.ts` compara as duas. A decisão que vale é a da API.
 */
export const ROOT_EMAIL_DOMAINS = ['westhetics.io', 'westhetics.com.br', 'bytewell.com.br'] as const

/** A recusa da API: a causa e o caminho. */
export const ROOT_EMAIL_REFUSAL =
  'Só entra na equipe da Westhetics quem tem e-mail @westhetics.io, @westhetics.com.br ou @bytewell.com.br. Use o e-mail da empresa.'

/** Um @ só, algo antes dele e, depois, exatamente um domínio da lista, sem diferença de caixa. */
export function isRootEmailAllowed(email: string): boolean {
  const parts = email.trim().toLowerCase().split('@')
  if (parts.length !== 2 || parts[0] === '') return false
  return (ROOT_EMAIL_DOMAINS as readonly string[]).includes(parts[1]!)
}
